import type { SVGProps } from 'react';
const SvgArrowIconThin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={7} height={13} fill="none" {...props}>
    <path d="m.5 12.5 6-6-6-6" />
  </svg>
);
export default SvgArrowIconThin;
